module.exports = __webpack_public_path__ + "img/ic_qrcode_lingying.618c46e.png";